import React, { HTMLAttributes } from 'react'

interface ContainerProps extends HTMLAttributes<HTMLDivElement> {}

export const Container = ({ children }: ContainerProps) => {
  return <div className="max-w-6xl mx-auto px-4 xl:px-0">{children}</div>
}
